import Component from '@glimmer/component';

export default class MwMycloudMenu extends Component {}
